import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Text = styled.p`
  font-size: ${theme.font.sizes.xxsmall};
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.semiBold};
  color: ${theme.colors.white};
  text-align: center;
`;

export const ConfirmButton = styled.button`
  background-color: ${theme.colors.blue400};
  border: none;
  border-radius: ${theme.border.mediumRadius};
  color: ${theme.colors.white};
  cursor: pointer;
  font-size: ${theme.font.sizes.normal};
  font-family: ${theme.font.poppins};
  padding: 10px 30px;
  margin-top: 20px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
`;
